<a (click)="_loginClientAs()" [attr.class]="aConfig.sClass? aConfig.sClass : null">Login</a>